import { fetchApiData, interpolate } from '../../Utils/ApiCalls';
import { COMPANY_SCOPES, SCOPE_RECORD_DETAIL_ENDPOINT } from '../../urls';
import { fetchScopeCatalog as fetchSharedScopeCatalog } from '../../Utils/scopeCatalog';

export { normalizeCatalog, scopeHasSelectableElements } from '../../Utils/scopeCatalog';

// Magic-link token in the URL is the scope-record id.

export const fetchScopeForm = async (token, { signal } = {}) =>
  fetchApiData({
    endpoint: interpolate(SCOPE_RECORD_DETAIL_ENDPOINT, [token]),
    apiRequest: 'GET',
    open: true,
    signal
  });

/** Public catalog — same get_scopes payload as staff console. */
export const fetchScopeCatalog = (_token, opts = {}) =>
  fetchSharedScopeCatalog({ ...opts, open: true });

/** Customer submit — same company_scopes endpoint as fill-on-behalf. */
export const submitScopeForm = async (token, body) => {
  const data = {
    card_id: token,
    scope_ids: body.selected_scope_ids,
    element_ids: body.selected_element_ids,
    modifier_answers: body.modifier_answers,
    notes_data: body.notes_data,
    submitted_by_email: body.submitted_by_email
  };
  Object.keys(data).forEach(k => {
    if (data[k] === undefined || data[k] === null || data[k] === '') delete data[k];
  });
  return fetchApiData({
    endpoint: COMPANY_SCOPES,
    apiRequest: 'POST',
    data,
    open: true
  });
};
